/**
 * Generated by orval
 * Do not edit manually
 * WorkflowXMApi, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */

export type DataFieldType = (typeof DataFieldType)[keyof typeof DataFieldType];

export const DataFieldType = {
  String: 0,
  Integer: 1,
  Decimal: 2,
  DateTime: 3,
  Boolean: 4,
  Guid: 5,
  Date: 6,
} as const;
